export type TopicStatus = "已核实" | "追证中" | "存疑" | "已澄清" | string;

export function statusClasses(status: TopicStatus): string {
  switch (status) {
    case "已核实":
      return "bg-secondary-100 text-secondary-900 border-secondary-300";
    case "追证中":
      return "bg-accent-100 text-accent-950 border-accent-300";
    case "存疑":
      return "bg-primary-100 text-primary-950 border-primary-300";
    case "已澄清":
      return "bg-background-200 text-foreground-800 border-background-400";
    default:
      return "bg-background-200 text-foreground-800 border-background-400";
  }
}

export function statusDot(status: TopicStatus): string {
  switch (status) {
    case "已核实":
      return "bg-secondary-500";
    case "追证中":
      return "bg-accent-500";
    case "存疑":
      return "bg-primary-500";
    case "已澄清":
      return "bg-foreground-500";
    default:
      return "bg-foreground-500";
  }
}

export function credibilityLabel(score: number): string {
  if (score >= 80) return "证据较充分";
  if (score >= 60) return "基本可信";
  if (score >= 40) return "存疑待查";
  return "依据不足";
}

export function credibilityBarColor(score: number): string {
  if (score >= 80) return "bg-secondary-500";
  if (score >= 60) return "bg-accent-500";
  return "bg-primary-500";
}

export function weightClasses(weight: string): string {
  switch (weight) {
    case "强":
      return "bg-secondary-100 text-secondary-900 border-secondary-300";
    case "中":
      return "bg-accent-100 text-accent-950 border-accent-300";
    default:
      return "bg-background-200 text-foreground-700 border-background-400";
  }
}